import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, setValue } from "react-hook-form";
import * as actions from '../actions/secmasteractions'
import { checkAccess } from '../../../actions/securityactions'

export default function GroupReports() {

    const state = useSelector(state => state.secmasterReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let checkPermissions = state.checkPermissions;
    let groupReports = state.assignGroupReports;
    let systemReports = groupReports.systemReports;
    console.log("systemReports", systemReports)
    const refGroupReports = useRef(null);

    const onResetGroupReportsSearch = () => { }

    const { register: registerGroupReportsSearch,
        reset: resetGroupReportsSearch, handleSubmit: onSubmitData, setValue: setGroupReportsSearchValue, watch: watchGroupReportsSearch, formState: { errors: errorsGroupReportsSearch } } = useForm();


    useEffect(() => {
        async function CheckPermissions() {
            await dispatch(checkAccess({ pageReportId: 3 }));
            //await dispatch(actions.getSystemReports());
            await dispatch(actions.getSecurityMasters());
        }
        CheckPermissions();
        scrollToBottom();
    }, []);

    useEffect(() => {
        scrollToBottom();
    }, [systemReports]);

    const scrollToBottom = () => {
        refGroupReports.current?.scrollIntoView({ behavior: 'smooth' });
    };
    const onError = (errorsGroupReportsSearch, e) => console.log(errorsGroupReportsSearch, e);

    const onCollapseSearch = () => {
        if (groupReports.searchClass === "collapse show") {
            //    dispatch(actions.collapseSearch(true));
        } else {
            //    dispatch(actions.collapseSearch(false));
        }
    }

    const saveAssignGroupReports = async () => {
        dispatch(actions.saveAssignGroupReports())
    }
    function resetAssignGroupReports() {
        dispatch(actions.resetAssignGroupReports())
    }
    function handleSystemReportRadioBtnChange(value, e) {
        dispatch(actions.handleSystemReportRadioBtnChange(value, e.target.checked))
    }




    function renderSystemReports() {
        if (systemReports.length == 0) {
            return <></>
        }

        return (
            <>

                <div class="list-group col-md-12 scrollspy-example" data-bs-spy="scroll" style={{ height: "750px" }}>
                    {systemReports.length > 0 && systemReports.map((systemReport, index) => (
                        <div className="mb-12 me-0">
                            <li class="list-group-item"><input type="checkbox" id={`checkbox_report${systemReport.reportId}`}
                                name={`checkbox_report${systemReport.reportId}`} className="form-check-input"
                                onChange={(e) => handleSystemReportRadioBtnChange(systemReport.reportId, e)}
                                checked={systemReport.isChecked}
                            />
                                <label className="form-check-label" htmlFor={`checkbox_report${systemReport.reportId}`}> &nbsp; {systemReport.reportName}</label>
                            </li>
                        </div>
                    ))}
                </div >




            </>
        )
    }


    return (

        <>

            <div className="content" ref={refGroupReports}>
                {/* <div className="row"> */}
                {/* <div className="col-6"> */}
                <div className="card ribbon-box">
                    <div className="card-body">
                        <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>Group Reports</div>

                        <div class="custmcontainer">
                            <div class="left-section">
                                <h5>
                                    {/* <i class="dripicons-view-list"></i> */} System Reports
                                </h5>
                                <hr />
                                <div className="row g-2">
                                    {renderSystemReports()}

                                </div>
                            </div>
                        </div>
                        <div className="row g-2">
                            <div class="modal-footer">

                                {checkPermissions.hasResetGroupReports && <button className='btn btn-danger' type="button" onClick={() => resetAssignGroupReports()} ><i className="mdi mdi-rotate-left" /> Reset</button>}
                                {checkPermissions.hasSaveGroupReports && <button className='btn btn-success' type="button" onClick={() => saveAssignGroupReports()} ><i class="dripicons-print"></i> Save</button>}
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div> */}
                {/* </div> */}
            </div>

        </>
    )
}